import { HazardAssessmentRecord, SavedHazardAssessment, HazardTypeRecord } from "../../models/ReferenceData/HazardAssessment";
import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import {
    userTypedRepairReasons,
    selectedRepairReasonObject,
    selectedRepairReasonDefaultPriority,
    selectedSorCode,
    sorErrorCode,
    selectedRepairReasonPriorityOverride,
    priorityCode
} from "../../ducks/redux/actions/dashboardReducer.actions";
import {
    userChosenHighLevelDescription,
    userChosenAdditionalDescription,
    userChosenAdditionalDescriptionCOUNT,
    userChosenSOR,
    userChosenSTATUS,
    userChosenEligibilityErrorCode,
    userChosenCovidQuestion,
    isEditState,
    userChosenVandalismQuestion,
    userChosenVandalismAdditionalInformation,
    userChosenVulnerabilityQuestion,
    userChosenVulnerabilityAdditionalInformation,
    userChosenDuplicateQuestion,
    userChosenEmergencyQuestion,
    userChosenUploadedMediaIdentifiers,
    clearMediaFiles,
    userChosenNotifyAll,
    dmcCheckSavedAnswer,
    selectedIsEmergencyValue,
    hasAdditionalNeeds,
    isSupportedResident
} from "../../ducks/redux/actions/userChoices";
import { PremisesType } from "../../models/Customer/Premises";
import * as api from "../../api";
import { useTranslation } from "react-i18next";
import {
    EligibilityErrorCode,
    MaintenanceResponsibility,
} from "../../models/Property";
import Loader from "react-loader-spinner";
import { RouteComponentProps } from "react-router-dom";
import {
    getHeatingHotWaterCase,
    getMaintResp,
    getRepairResp,
    getContractorName,
    getDeterminedContractorDetails,
    getContractorPayload,
    workOrderRepairObject,
} from "../../ducks/redux/actions/getAddress";
import { SorErrorEnumCode } from "../../models/Repair/SorErrorEnumCode";
import { getRepairPriority, isNullOrUndefined } from "../../utils/formatting";
import { RepairPriorityCode, RepairPriority } from "../../models/Repair/CreateRepair";
import { PermissionsList } from "../../models/Permissions";
import { repairPriorityRequest } from "../../models/Repair/RepairReason";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import moment from "moment";
import { SorDeterminationResponse } from "../../models/WorksOrders";
import { removeAllDMCData, saveHazardType, saveHHSRSOption, saveSaverityScore, storeSORDAMP } from "../../ducks/redux/actions/FinancialReferral";
import { GetRepairEligibilityOptions } from "../../api";
import { saveHazardAssessment, resetHazardAssessmentData, saveHazardGetQuestionsData, savePreAssessmentQuestionsData, saveHHSRSAssessmentCompleted, addHazardAssessmentAnswer, saveHazardPostAssessmentResponse, saveActiveHazardCaseDetails, saveActivePopHazardCaseFlag, SavehasActiveHazardCase} from "../../ducks/redux/actions/hazardAssessment";
import { Helper } from "../../utils/Helper/HelperUtil";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";

export interface RepairReasonProps extends RouteComponentProps<any> {
    suggestions: string[];
    setisDisabled: (a: boolean) => void;
    setisDisabledOrbis: (a: boolean) => void;
    onRepairReasonLoadingChange?: (loading: boolean) => void;
    locatioAlert: string[];
    getMandatoryData: (args: any) => void;


}
const isFlowIneligibleForHazardRepair = (asset: any, reason: any, isRecall: boolean, isSection8LeaseHold: boolean): boolean =>
    Boolean(isRecall || asset?.statuses?.isInDefects || isSection8LeaseHold || asset?.maintenanceResponsibilities?.some((responsibility: any) =>
        (responsibility.type === "MAINTSRESP" || responsibility.type === reason?.element) && responsibility.value === "EMAFULL"));

const restoreHazardAssessment = (assessment: HazardAssessmentRecord, workOrder: any, assetType: string): SavedHazardAssessment => {
    const conditions = assessment.outcome?.overridingConditions;
    return {
        identifier: assessment.id,
        request: {
            assetType, hazardType: assessment.hazardType,
            contractorRating: conditions?.contractorRating ?? null,
            hasAdditionalNeeds: conditions?.hasAdditionalNeeds ?? Boolean(workOrder?.assessmentInformation?.hasAdditionalNeeds),
            isSupportedResident: conditions?.isSupportedResident ?? Boolean(workOrder?.assessmentInformation?.isSupportedResident),
            responses: assessment.responses.map((response) => ({ ...response, answers: [...response.answers] })),
        },
        repairType: workOrder?.sorCode,
        isEmergency: Boolean(workOrder?.isEmergency),
        outcome: {
            id: assessment.id, hazardType: assessment.hazardType, score: assessment.outcome?.score ?? null,
            risk: assessment.outcome?.risk ?? null, actions: assessment.outcome?.actions ?? null
        },
    };
};

const RepairReason: React.FC<RepairReasonProps> = (props) => {
    const dispatch = useDispatch();
    const repairReasonRequestVersion = React.useRef(0);
    const isCurrentRepairReason = (requestVersion: number) =>
        repairReasonRequestVersion.current === requestVersion;
    const { t } = useTranslation();
    let suggestionList;
    const userChosenHighLevelDescriptionBackButton = useSelector(
        (state: any) => state?.userChoicesReducer?.userChosenHighLevelDescription
    );
    const [isSection8LeaseHold, setIsSection8LeaseHold] = useState(false);
    const [showAlertsAndWarningsDisplay, setShowAlertsAndWarningsDisplay] = React.useState("none");
    const [errorCode, setErrorCode] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);
    const [inputValue, setInputValue] = useState("");
    const [isHazardRepair, setIsHazardRepair] = useState(false);
    const isHHSRSAssessmentCompletedCheck = useSelector((state: any) => state?.hazard?.isHHSRSAssessmentCompleted);
    const savedHazardResponses = useSelector((state: any) => state?.hazard?.responses || []);
    const savedHazardAssessment = useSelector((state: any) => state?.hazard?.savedAssessment);
    const resumeDraftRepair = useSelector((state: any) => state?.userChoicesReducer?.resumeDraftRepair);
    const [showResumedEmergencyDropdown, setShowResumedEmergencyDropdown] = useState(false);
    const [isSelectedValue, setSelectedValue] = React.useState(false);
    const [sorError, setSorError] = useState("");
    const [sorList, setSorList] = useState([{}]);
    const [sorValue, setSorValue] = useState("");
    const [isOrbisBlockMsg, setIsOrbisBlockMsg] = React.useState(false);
    const [blockLoading, setBlockLoading] = useState(false);
    const [emergencyAlertText, setEmergencyAlertText] = useState("RepairLocation_No_Emergency_Text");
    const EditState = useSelector((state: any) => state.userChoicesReducer?.isEditState);
    const extractedReasons: string[] = [];
    const [fetchedRepairReasonsData, setFetchedRepairReasonsData] = useState(extractedReasons);
    //Check Repair Eligibility
    let premisesType = "";
    let maintsResp = "FMFULL";
    let repairResp = "";
    let additionalRepairInfo = false; //!!asset?.description //??
    let isRepairEligible = true;
    let isCustomerView = false; // to do discuss
    let uprn = ""; // asset store - filter
    let sorCode: string | null = "";
    let isInDefects = false; //got
    let heatingRepairContext: string | null = "";
    let sorErrorCodeValue = "";
    const [displayEmergencyValue, setDisplayEmergencyValue] = useState("No");
    const assetSubType = useSelector((state: any) => state?.financialReferralReducer?.assetSubType);
    const parentAssetType = useSelector((state: any) => state?.financialReferralReducer?.parentAssetType);
    const priorityCodeValue = useSelector(
        (state: any) => state.dashboardReducer.formState?.priorityCode
    );

    const [priorityFromDrools, setpriorityFromDrools] = useState(priorityCodeValue);

    const selectedSor = useSelector(
        (state: any) => state?.dashboardReducer?.formState?.selectedSorCode
    );
    const sorErrorValue = useSelector(
        (state: any) => state?.dashboardReducer?.formState?.sorErrorCode
    );
    const selectedSorCodeValue = useSelector(
        (state: any) => state?.userChoicesReducer?.userChosenSOR
    );

    const userResumeDraftDataCache = useSelector(
        (state: any) => state.userChoicesReducer?.userResumeDraftDataCache ?? null
    );
   
    const [isRecallValue, setIsRecallValue] = useState(false);
    const IsRecall = useSelector(
        (state: any) => state.userChoicesReducer?.IsRecall
    );

    const getPermissionsData = useSelector(
        (state: any) => state?.userChoicesReducer?.userProfilePermissions
    );
    const hazards = useSelector((state: any) => state.hazard?.hazardDetails);
    let workorderChoosePriorityOfRepairPermission = getPermissionsData?.indexOf(PermissionsList.workorder_choose_priority_of_repair) >= 0;
    let workorderNoTriageForHHWRepairsPremission = getPermissionsData?.indexOf(PermissionsList.workorder_no_triage_forheatingandhotwaterrepairs) >= 0;

    const fetchedRepairReasonsSelection = useSelector(
        (state: any) =>
            state?.dashboardReducer?.formState?.fetchedRepairReasonsSelect
    );

    const RepairLocationId = useSelector(
        (state: any) => state?.userChoicesReducer?.userChosenRepairLocationId
    );
    const repairAssetData = useSelector(
        (state: any) => state?.userChoicesReducer?.repairAddressData
    );

    const priority = useSelector(
        (state: any) =>
            state?.dashboardReducer?.formState?.selectedRepairReasonPriorityOverride ??
            state?.dashboardReducer?.formState?.selectedRepairReasonObject?.[0]?.priority
    );
    const assetDetails = useSelector(
        (state: any) =>
            state?.dashboardReducer?.formState?.assetByIdDataObject
    );

    const fetchRepairReasonsInProgressFromState = useSelector(
        (state: any) => state.dashboardReducer.formState?.fetchRepairReasonsInProgress
    );
    const selTenancyGroup = useSelector(
        (state: any) => state?.userChoicesReducer?.selectedTenancyGroup
    );
    const selectedRepairReason = useSelector(
        (state: any) =>
            state?.dashboardReducer?.formState?.selectedRepairReasonObject
    );
    const workOrderObject = useSelector(
        (state: any) => state?.addresses?.workOrderRepair
    );
    const isResumedRepair = resumeDraftRepair &&
        selectedRepairReason?.[0]?.description === userResumeDraftDataCache?.repairReason;
    const currentPriorityCode = useSelector((state: any) => state?.dashboardReducer?.formState?.priorityCode);
    const savedHazardQuestions = useSelector(
        (state: any) => state?.hazard?.hazardQuestions
    );
    const savedPreAssessmentJourneyQuestions = useSelector(
        (state: any) => state?.hazard?.preAssessmentJourneyQuestions
    );

    const supplimentaryCodes = useSelector(
        (state: any) => state.userChoicesReducer?.supplimentaryCodes
    );

    const customerResponse = useSelector(
        (state: any) => state.addresses?.saveCustomerDetails
    );

    const customerAdditionalAlertData = useSelector(
        (state: any) => state?.userChoicesReducer?.customerAdditionalAlertData
    );
    const dmcInspectionSorCodes = useSelector(
        (state: any) => state?.userChoicesReducer?.dmcInspectionSorCodeValues
    );

    let subSessionAssetsEligibilityDetailsRedux = useSelector(
        (state: any) => state?.addresses?.subSessionAssetsEligibilityDetails
    );

    const isHHSRSRepairEnabledCheck = useSelector((state: any) => state?.userChoicesReducer?.isHHSRSRepairEnabled);
    let emergencyDropDownSelectedValue = 'Yes';
    let sorDeterminationResponse = new SorDeterminationResponse();

    useEffect(() => {
        //set isEmergency ddl value in case od Edit
        const isRepairEmergency = priority == RepairPriority.Emergency || userResumeDraftDataCache?.emergencyQuestion == t("Repair_Emergency_Radio1_Text");

        if (!workOrderObject?.assessmentInformation?.identifier && !workOrderObject?.assessmentIdentifier) {
            dispatch(selectedRepairReasonPriorityOverride(isRepairEmergency ? RepairPriority.Emergency : RepairPriority.NextAvailable));
        }

        setDisplayEmergencyValue(isRepairEmergency ? "Yes" : "No")
        setIsRecallValue(IsRecall)
        setSorValue(selectedSorCodeValue);

        if (isNullOrUndefined(sorErrorValue)) {
            updateStoreForNewRepairReasonSelection(userChosenHighLevelDescriptionBackButton, false, props.history.action !== "PUSH");
        }
        else {
            setSorList(selectedSor);
            setSorError(sorErrorValue);
            props.setisDisabled(true);
            props.onRepairReasonLoadingChange?.(false);
        }

        if (props.history.action === "POP") {
            setInputValue(userChosenHighLevelDescriptionBackButton);

            const disableContinueButton = sorErrorValue == SorErrorEnumCode.E28 ||
                sorErrorValue == SorErrorEnumCode.E29 ||
                sorErrorValue == SorErrorEnumCode.E30 ||
                sorErrorValue == SorErrorEnumCode.E31 ||
                (sorErrorValue == SorErrorEnumCode.E32 &&
                    (isNullOrUndefined(selectedSorCodeValue) ||
                        selectedSorCodeValue == "Select"))

            props.setisDisabled(disableContinueButton);
        }
        const currentAssetCachedEligibilityOutcome = subSessionAssetsEligibilityDetailsRedux?.find((assetEligDetailEle: any) => assetEligDetailEle.assetId === assetDetails?.id);
        const assetEligibility = currentAssetCachedEligibilityOutcome?.assetEligibilityResponse;
        setIsSection8LeaseHold(assetEligibility?.supplimentaryCodes?.includes("LHLDSECTION8"));
        return () => {
            repairReasonRequestVersion.current += 1;
        };
    }, []);

    useEffect(() => {
        const fetchAppConfigHotjarToggleValue = async () => {
            // Getting SOR from app config
            const SORConfig = await api.GetAppConfigToggleValue(
                "dmcsorcodes"
            );
            dispatch(storeSORDAMP(SORConfig?.value))
            if (userChosenHighLevelDescriptionBackButton) {
                setInputValue(userChosenHighLevelDescriptionBackButton);
                setDisplayEmergencyValue(priority == RepairPriority.Emergency ? "Yes" : "No");
            }
        };
        fetchAppConfigHotjarToggleValue();
    }, []);


    useEffect(() => {
        setRepairPriorityMessageForEnhancedHubRepairJourney(workorderChoosePriorityOfRepairPermission, displayEmergencyValue);
    }, [displayEmergencyValue, priorityFromDrools]);


    const enableButtonPermission = () => {
        if (sorError == SorErrorEnumCode.E32) {
            // Colleague isnt allowed to provide heating element details
            dispatch(userChosenSOR("NA"));
            props.setisDisabled(workorderNoTriageForHHWRepairsPremission);
            setSorValue("NA");
        }
    }

    const setRepairPriorityMessageForEnhancedHubRepairJourney = (workorderChoosePriorityOfRepairPermission: any, priority: any) => {
        (async () => {
            if (workorderChoosePriorityOfRepairPermission) {
                if (priority === "Yes" && dmcInspectionSorCodes?.includes(selectedSorCodeValue)) {
                    setEmergencyAlertText("RepairLocation_Emergency_Text_Prodamp");
                } else if (priority === "Yes") {
                    setEmergencyAlertText("RepairLocation_Emergency_Text");
                } else if (priorityFromDrools === RepairPriorityCode.DampAndMould) {
                    setEmergencyAlertText("RepairLocation_DM_Text");
                } else if (priorityFromDrools === RepairPriorityCode.V14) {
                    setEmergencyAlertText("RepairLocation_V14_Text");
                } else {
                    setEmergencyAlertText("RepairLocation_No_Emergency_Text");
                }
            }
        })()
    };

    useEffect(() => {
        setErrorCode("")
        props.getMandatoryData(inputValue);
    }, [inputValue]);

    const handleChangeSorCode = (e: { target: { value: any } }) => {
        if (!isNullOrUndefined(e?.target?.value) && e.target.value !== "Select") {
            dispatch(userChosenSOR(e.target.value));
            setSorValue(e.target.value);
            props.setisDisabled(false);
        } else {
            dispatch(userChosenSOR("NA"));
            props.setisDisabled(true);
            setSorValue(e.target.value);

        }
    };
    const restoreSavedAssessmentAnswers = async (allQuestions: any[], requestVersion: number, isPreAssessmentRequired: boolean) => {
        const savedAssessmentIdentifier =
            workOrderObject?.assessmentInformation?.identifier || workOrderObject?.assessmentIdentifier;

        if (!savedAssessmentIdentifier) {
            setShowResumedEmergencyDropdown(isPreAssessmentRequired);
            return;
        }
        if (savedHazardResponses?.length) {
            setShowResumedEmergencyDropdown(isPreAssessmentRequired &&
                savedHazardAssessment?.identifier === savedAssessmentIdentifier &&
                savedHazardAssessment?.outcome?.score?.combined === 0);
            return;
        }

        const savedAssessment = await api.getHazardAssessment(savedAssessmentIdentifier);
        if (!isCurrentRepairReason(requestVersion)) {
            return;
        }
        setShowResumedEmergencyDropdown(isPreAssessmentRequired && savedAssessment.outcome?.score?.combined === 0);
        dispatch(saveHazardAssessment(restoreHazardAssessment(savedAssessment, workOrderObject, assetDetails.assetType)));
        dispatch(hasAdditionalNeeds(savedAssessment.outcome?.overridingConditions?.hasAdditionalNeeds ?? Boolean(workOrderObject?.assessmentInformation?.hasAdditionalNeeds)));
        dispatch(isSupportedResident(savedAssessment.outcome?.overridingConditions?.isSupportedResident ?? Boolean(workOrderObject?.assessmentInformation?.isSupportedResident)));

        savedAssessment?.responses?.forEach((savedResponse: any) => {
            const question = allQuestions.find((item: any) => item.code === savedResponse.code);
            if (!question || !savedResponse.answers?.length) {
                return;
            }

            dispatch(addHazardAssessmentAnswer({
                sequence: question.sequence,
                question: question.label,
                answers: [...question.options]
                    .sort((first: any, second: any) =>
                        first.code.localeCompare(second.code, undefined, { numeric: true })
                    )
                    .filter((option: any) => savedResponse.answers.includes(option.code))
                    .map((option: any) => option.text),
                answerCodes: [...savedResponse.answers],
                code: question.code,
                isPreAssessment: Helper.isPreAssessmentCategory(question.category),
            }));
        });

        if (savedAssessment?.outcome) {
            dispatch(saveHazardPostAssessmentResponse({
                id: savedAssessment.id,
                hazardType: savedAssessment.hazardType,
                ...savedAssessment.outcome,
            }));
        }
    };

    const handleHazardQuestionsError = (error: unknown, isPreAssessmentRequired: boolean, requestVersion: number) => {
        if (!isCurrentRepairReason(requestVersion)) {
            return;
        }
        console.error(error);
        dispatch(saveHazardGetQuestionsData([]));
        if (isPreAssessmentRequired) {
            dispatch(savePreAssessmentQuestionsData([]));
        }
        props.history.push("/GenericError");
        throw error;
    };

    const handleActiveHazardCaseResult = (
        activeHazardCaseResult: string | null,
        isPreAssessmentRequired: boolean
    ) => {
        if (activeHazardCaseResult) {           
            setShowResumedEmergencyDropdown(true)            
            dispatch(saveHHSRSAssessmentCompleted(false))// hazard Assessment will not come in active crm POP Case
        }
        dispatch(saveActivePopHazardCaseFlag(!!activeHazardCaseResult));
        setHazardRepairState(activeHazardCaseResult, isPreAssessmentRequired);
    };

    const loadHazardQuestionsForRepairReason = async (
        selectedReason: any[],
        hasRepairReasonChanged: boolean,
        requestVersion: number
    ) => {

        const repairReason = selectedReason?.[0];
        const isPreAssessmentRequired = repairReason?.isPreAssessmentRequired === true;
        const isHazardRepairReason = repairReason?.isHazard === true;

        if (!isValidRepairReasonType(isPreAssessmentRequired, isHazardRepairReason)) {
            return;
        }

        const assetType = assetDetails?.assetType?.toUpperCase();
        const hazardType = repairReason?.hazardType;
        const diagnosticId = repairReason?.diagnosticId;
        const preAssessmentCategory = isPreAssessmentRequired &&
            diagnosticId !== undefined &&
            diagnosticId !== null
            ? `${Helper.PreAssessment.CategoryPrefix}${diagnosticId}`
            : "";

        if (!validateAssetAndCategory(assetType, hazardType, preAssessmentCategory, isPreAssessmentRequired)) {
            setShowResumedEmergencyDropdown(isPreAssessmentRequired);
            return;
        }

        const hasCachedQuestions = hasCachedQuestionsData(isPreAssessmentRequired, preAssessmentCategory);
        const cachedQuestions = getCachedQuestionsData(isPreAssessmentRequired);

        try {
            let allQuestions = cachedQuestions;
            if (hasRepairReasonChanged || !hasCachedQuestions) {
                const response = isPreAssessmentRequired
                    ? await api.getHHSRSHazardQuestions(
                        assetType,
                        hazardType,
                        true,
                        preAssessmentCategory
                    )
                    : await api.getHHSRSHazardQuestions(assetType, hazardType);

                if (!isCurrentRepairReason(requestVersion)) {
                    return;
                }
                allQuestions = response?.[0]?.questions || [];
                savePreassessmentQuestions(isPreAssessmentRequired, allQuestions);
                dispatch(saveHazardGetQuestionsData(
                    allQuestions.filter((question: any) =>
                        !Helper.isPreAssessmentCategory(question.category)
                    )
                ));
            }
            await restoreSavedAssessmentAnswers(allQuestions, requestVersion, isPreAssessmentRequired);
            if (!isCurrentRepairReason(requestVersion)) {
                return;
            }
            const activeHazardCaseResult = await getActiveHazardCaseId(selectedReason, allQuestions)
            if (!isCurrentRepairReason(requestVersion)) {
                return;
            }
            handleActiveHazardCaseResult(activeHazardCaseResult, isPreAssessmentRequired);
        } catch (e) {
            handleHazardQuestionsError(e, isPreAssessmentRequired, requestVersion);
        }
    };

    const savePreassessmentQuestions = (isPreAssessmentRequired:any,questions: any[]) => {
            if (isPreAssessmentRequired) {
                dispatch(savePreAssessmentQuestionsData(questions));
            }
    }

    const isValidRepairReasonType = (isPreAssessmentRequired: boolean, isHazardRepairReason: boolean): boolean => {
        return isPreAssessmentRequired || isHazardRepairReason;
    };

    const validateAssetAndCategory = (assetType: string, hazardType: string, preAssessmentCategory: string, isPreAssessmentRequired: boolean): boolean => {
        return !!assetType && !!hazardType && (!isPreAssessmentRequired || !!preAssessmentCategory);
    };

    const getCachedQuestionsData = (isPreAssessmentRequired: boolean): any[] => {
        return isPreAssessmentRequired ? savedPreAssessmentJourneyQuestions : savedHazardQuestions;
    };

    const hasCachedQuestionsData = (isPreAssessmentRequired: boolean, preAssessmentCategory: string): boolean => {
        if (isPreAssessmentRequired) {
            return savedPreAssessmentJourneyQuestions?.some((question: any) =>
                Helper.isMatchingPreAssessmentCategory(question.category, preAssessmentCategory)
            );
        }
        return savedHazardQuestions?.length > 0;
    };

    const setHazardRepairState = (activeHazardCaseResult: string | null, isPreAssessmentRequired: boolean): void => {
        setIsHazardRepair(!(activeHazardCaseResult && !isPreAssessmentRequired));
    };

    const getHazardTypeDescription = (hazardTypeCode?: string): string => {
        if (!hazardTypeCode) return "";
        const matchedHazard = (hazards as HazardTypeRecord[] | undefined)?.find(
            (hazard) =>
                hazard?.hazardType?.trim().toUpperCase() ===
                hazardTypeCode.trim().toUpperCase()
        );
        return matchedHazard?.description ?? "";
    };

    const getActiveHazardCaseId = async (selectedReason: any, allQuestions: any[]): Promise<string | null> => {
        if (allQuestions?.length === 0) {
            dispatch(SavehasActiveHazardCase(false));
            return null;
        }

        const caseType = getHazardTypeDescription(selectedReason?.[0]?.hazardType);
        const queryParams: any = {
            assetIdentifiers: [assetDetails?.id ?? ""],
            searchText: "",
            status: "Active",
            orderBy: "createdDate desc",
            limit: 1,
            skip: 0,
            ownerEmailId: "",
            assetType: assetDetails?.assetType,
            caseSubType: caseType,
            caseSubTypeCategory: caseType
        };

        try {
            const res = await api.getCaseData(queryParams);
            const hasActiveCase =
                Array.isArray(res?.cases) &&
                res.cases.length > 0 &&
                res?.["total-count"] !== 0;

            dispatch(SavehasActiveHazardCase(hasActiveCase));
            dispatch(saveActiveHazardCaseDetails(res?.cases[0]));

            return hasActiveCase
                ? res.cases[0]?.identifiers?.caseIdentifier ?? null
                : null;
        } catch (e) {
            console.error(e);
            return null;
        }
    };

    const resetAssessmentForNewRepairReason = () => {
        dispatch(userChosenAdditionalDescription(""));
        dispatch(userChosenAdditionalDescriptionCOUNT(0));
        dispatch(resetHazardAssessmentData());
        dispatch(saveHazardGetQuestionsData([]));
        dispatch(savePreAssessmentQuestionsData([]));
        if (workOrderObject) {
            workOrderObject.additionalInformation = "";
            workOrderObject.assessmentIdentifier = undefined;
            workOrderObject.hazardSorCode = undefined;
            workOrderObject.hhsrsAssessment = undefined;
            workOrderObject.assessmentInformation = undefined;
            if (workOrderObject.repairCauseId === Helper.HHSRSRepairCauseId) {
                workOrderObject.repairCauseId = Helper.GeneralWearandTear;
                workOrderObject.repairCause = Helper.RepairCauseLabels[Helper.GeneralWearandTear];
            }
            dispatch(workOrderRepairObject(workOrderObject));
            dispatch(saveHHSRSAssessmentCompleted(false));
        }
    };

    const clearMismatchedPreAssessmentQuestions = (selectedReason: any) => {
        if (selectedReason?.[0]?.isPreAssessmentRequired === true &&
            savedPreAssessmentJourneyQuestions?.length > 0 &&
            !savedPreAssessmentJourneyQuestions.some((question: any) =>
                Helper.isMatchingPreAssessmentCategory(
                    question.category,
                    `${Helper.PreAssessment.CategoryPrefix}${selectedReason[0].diagnosticId}`
                )
            )) {
            dispatch(savePreAssessmentQuestionsData([]));
        }
    };

    const prepareRepairEligibility = (selectedReason: any, preserveAssessmentDecisions: boolean) => {
        // setIsLoading(false)
        premisesType = assetDetails?.assetType;

        maintsResp = assetDetails?.maintenanceResponsibilities?.find(
            (resp: any) => resp.type === "MAINTSRESP"
        )?.value ?? "";

        repairResp = assetDetails?.maintenanceResponsibilities?.find(
            (resp: any) => resp.type === selectedReason[0]?.element
        )?.value ?? "";

        if (selectedReason[0]?.additionalData?.length > 0) {
            additionalRepairInfo = selectedReason[0]?.additionalData[0]?.description != "";
        } else {
            additionalRepairInfo = false;
        }
        //start logic to get isEligibleRepair
        const repairAdditionalData = selectedReason[0].additionalData.find(
            (item: any) =>
                item.assetType === assetDetails?.assetType &&
                item.tenancyTypes?.some(
                    (tt: any) =>
                        tt.toLowerCase() ===
                        selTenancyGroup.toLowerCase()
                )
        );

        isRepairEligible = assetDetails?.assetStatus === "VOID" || (repairAdditionalData?.isEligible ?? false);
        // end
        isCustomerView = true; // as discussed true for customer search
        uprn = assetDetails.uprn;
        sorCode = preserveAssessmentDecisions ? workOrderObject.sorCode : selectedReason[0]?.sors[0]?.sorCode;
        const status = assetDetails?.statuses?.isInDefects;
        isInDefects = status;

        dispatch(userChosenSOR(sorCode));
        dispatch(userChosenSTATUS("Unappointed,Appointed,In Progress"));

        dispatch(getMaintResp(maintsResp));
        dispatch(getRepairResp(repairResp));
    };

    const updateStoreForNewRepairReasonSelection = async (value: string, hasUserSelectedRepairReason: boolean, userSelectedBack: boolean = false) => {
        const requestVersion = ++repairReasonRequestVersion.current;
        setShowResumedEmergencyDropdown(false);
        props.onRepairReasonLoadingChange?.(true);
        try {
            setIsLoading(true);
            setIsOrbisBlockMsg(false);
            props.setisDisabledOrbis(false);
            props.setisDisabled(true);
            const selectedReason = fetchedRepairReasonsSelection?.filter(
                (reason: any) => reason.description === value
            );

            const preserveAssessmentDecisions = Boolean(workOrderObject?.assessmentInformation?.identifier || workOrderObject?.assessmentIdentifier) &&
                selectedReason?.[0]?.description === (workOrderObject?.repairReason || workOrderObject?.description);
            if (!preserveAssessmentDecisions && selectedReason?.length > 0 && selectedReason[0].sors.length > 0 && selectedReason[0].sors[0].sorCode) {
                selectedReason[0].sors[0].sorCode = getSorCode(selectedReason[0], supplimentaryCodes)
            }
            dispatch(selectedSorCode(selectedReason[0]?.sors));
            setSorList(selectedReason[0]?.sors);
            const hasRepairReasonChanged =
                hasUserSelectedRepairReason &&
                selectedReason?.length > 0 &&
                selectedReason[0]?.description !== selectedRepairReason?.[0]?.description;

            if (hasRepairReasonChanged) {
                resetAssessmentForNewRepairReason();
            } else {
                clearMismatchedPreAssessmentQuestions(selectedReason);
            }
            dispatch(selectedRepairReasonObject(selectedReason));
            dispatch(selectedRepairReasonDefaultPriority(selectedReason[0]?.priority))
            //call api and set params values

            if (assetDetails && selectedReason?.length > 0) {
                prepareRepairEligibility(selectedReason, preserveAssessmentDecisions);
                await callGetSorDetermination(selectedReason, userSelectedBack, preserveAssessmentDecisions, hasUserSelectedRepairReason, hasRepairReasonChanged, requestVersion)
            }
        } catch (e) {
            if (!isCurrentRepairReason(requestVersion)) {
                return;
            }
            props.setisDisabled(true);
            props.history.push("/GenericError");
            setIsLoading(false);
            console.error(e);
        } finally {
            if (isCurrentRepairReason(requestVersion)) {
                setIsLoading(false);
                props.onRepairReasonLoadingChange?.(false);
            }
        }
    };

    const applySorDetermination = async (selectedReason: any, requestVersion: number) => {
        if (
            sorCode === "COMHIU" &&
            sorDeterminationResponse?.repairContext !== "N/A"
        ) {
            heatingRepairContext = sorDeterminationResponse.repairContext;
            dispatch(userChosenSOR(sorCode));
            setShowAlertsAndWarningsDisplay("none");
            await checkRepairEligibility(selectedReason, sorCode, false, requestVersion);
        } else if (sorDeterminationResponse?.errorCode) {
            sorErrorCodeValue = sorDeterminationResponse?.errorCode;
            if (sorDeterminationResponse.errorCode === "E32") {
                setSorError(sorDeterminationResponse?.errorCode)
                setShowAlertsAndWarningsDisplay("block");
                props.setisDisabled(!isSelectedValue);
                dispatch(userChosenSOR("NA"));
                dispatch(getHeatingHotWaterCase(sorDeterminationResponse.errorCode));
            }
            setShowAlertsAndWarningsDisplay("block");
            props.setisDisabled(true);
        } else {
            sorCode = sorDeterminationResponse.sor;
            dispatch(userChosenSOR(sorCode));
            setShowAlertsAndWarningsDisplay("none");
            await checkRepairEligibility(selectedReason, sorDeterminationResponse?.sor, false, requestVersion);
        }
    };

    const determineRepairSor = async (selectedReason: any, loadWithPreviousDataScenario: boolean, hasUserSelectedRepairReason: boolean, requestVersion: number) => {
        let maintenanceResponsibilities: MaintenanceResponsibility[] = [];
        // get maintenanceResponsibilities for all assets
        const assetHierarchy = repairAssetData.flat();
        const addressHierarchyDetailPromises = assetHierarchy.map((item: any) => {
            return api.getAssetsByid(item.id);
        });
        const addressHierarchyDetail = await Promise.all(addressHierarchyDetailPromises);
        if (!isCurrentRepairReason(requestVersion)) {
            return;
        }
        let propertyAttribute = "", dividedBlockAttribute = "", blockAttribute = "", estateAttribute = "";

        addressHierarchyDetail.forEach((asset: any) => {
            const responsibilities = heatingAttributeFromResponsibilities(
                asset.maintenanceResponsibilities
            );
            const rep = {
                type: asset.assetType,
                value: responsibilities,
            };
            maintenanceResponsibilities.push(rep);
        });

        if (maintenanceResponsibilities?.length > 0) {
            propertyAttribute =
                maintenanceResponsibilities.find(
                    (item) => item.type === PremisesType.Property
                )?.value ?? "";
            dividedBlockAttribute =
                maintenanceResponsibilities.find(
                    (item) => item.type === PremisesType.DividedBlock
                )?.value ?? "";
            blockAttribute =
                maintenanceResponsibilities.find(
                    (item) => item.type === PremisesType.Block
                )?.value ?? "";
            estateAttribute =
                maintenanceResponsibilities.find(
                    (item) => item.type === PremisesType.Estate
                )?.value ?? "";

        }
        // call sor determination api
        setBlockLoading(true);
        sorDeterminationResponse = await api.getSorDetermination({
            propertyAttribute,
            dividedBlockAttribute,
            blockAttribute,
            estateAttribute,
            context: assetDetails.assetType as PremisesType,
        });
        if (!isCurrentRepairReason(requestVersion)) {
            return;
        }
        if (!sorDeterminationResponse) {
            return;
        }
        await applySorDetermination(selectedReason, requestVersion);
        if (!isCurrentRepairReason(requestVersion)) {
            return;
        }
        if (
            sorDeterminationResponse?.errorCode == "E32" ||
            sorDeterminationResponse?.errorCode == "E31" ||
            sorDeterminationResponse?.errorCode == "E30" ||
            sorDeterminationResponse?.errorCode == "E29" ||
            sorDeterminationResponse?.errorCode == "E28"
        ) {
            setSorError(sorDeterminationResponse?.errorCode);

            dispatch(sorErrorCode(sorDeterminationResponse?.errorCode));
            setIsLoading(false)
            props.setisDisabled(true);
        }

        //CheckEnhancedRepairEligibilities will be required after SOR determination if rules are SOR specific
        if (!loadWithPreviousDataScenario || hasUserSelectedRepairReason) {
            // Check ony if user has come from Repair Asset and typing a new repair reason or user selects the new repair reason
            dispatch(selectedRepairReasonPriorityOverride(null));
            await checkForRepairPriorityUpdates(selectedReason, requestVersion);
        }
        if (isCurrentRepairReason(requestVersion)) {
            setBlockLoading(false);
        }
    };

    const callGetSorDetermination = async (selectedReason: any, userSelectedBack: any, preserveAssessmentDecisions: any, hasUserSelectedRepairReason: any, hasRepairReasonChanged: any, requestVersion: number) => {
        const loadWithPreviousDataScenario = !isNullOrUndefined(userResumeDraftDataCache?.emergencyQuestion) || userSelectedBack;
        const isExcludedFromHazard = isFlowIneligibleForHazardRepair(assetDetails, selectedReason[0], IsRecall, isSection8LeaseHold);

        if (selectedReason[0]?.isHazard === true &&
            isHHSRSRepairEnabledCheck &&
            !isExcludedFromHazard) {
            setIsHazardRepair(true);
            await loadHazardQuestionsForRepairReason(selectedReason, hasRepairReasonChanged, requestVersion);
            if (!isCurrentRepairReason(requestVersion)) {
                return;
            }
        }
        else {
            setIsHazardRepair(false);
            setShowResumedEmergencyDropdown(true);
            if (isExcludedFromHazard) dispatch(resetHazardAssessmentData());
        }
        if (selectedReason[0]?.isSORDeterminationRequired === true) {
            await determineRepairSor(selectedReason, loadWithPreviousDataScenario, hasUserSelectedRepairReason, requestVersion);
            return;
        }
        await checkRepairEligibility(selectedReason, sorCode, preserveAssessmentDecisions, requestVersion);
        if (!isCurrentRepairReason(requestVersion)) {
            return;
        }
        if (!preserveAssessmentDecisions && (!loadWithPreviousDataScenario || hasUserSelectedRepairReason)) {
            // Check ony if user has come from Repair Asset and typing a new repair reason or user selects the new repair reason
            dispatch(selectedRepairReasonPriorityOverride(null));
            await checkForRepairPriorityUpdates(selectedReason, requestVersion);
        }

    }

    const priorityDeterminationCallAPI = async (selectedReason: any, requestVersion = repairReasonRequestVersion.current) => {
        const sorCodeValue = sorDeterminationResponse.sor !== ''
            ? sorDeterminationResponse.sor : selectedReason?.[0]?.sors[0]?.sorCode;
        const priorityWorkProgramme = sorDeterminationResponse.sor != ''
            ? selectedReason?.[0]?.sors.find((sor: any) => sor?.sorCode === sorCodeValue)?.workProgramme
            : selectedReason?.[0]?.sors[0]?.workProgramme;

        const isAnaTypeValue = customerAdditionalAlertData?.length > 0;
        dispatch(hasAdditionalNeeds(isAnaTypeValue));

        let tenureCode = "";
        if (customerResponse?.tenanciesSummaries?.length > 1) {
            const tenancySummary = customerResponse?.tenanciesSummaries?.filter(
                (tenancy: any) =>
                    tenancy?.tenancySummary?.tenancyEndDate === null
            );
            tenureCode = tenancySummary[0]?.tenancySummary?.tenancyTenureCode;
        }
        else {
            tenureCode = customerResponse?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode;
        }

        const repairPriorityPayload: repairPriorityRequest = {
            isEmergency: selectedReason?.[0]?.priority == RepairPriority.Emergency && emergencyDropDownSelectedValue === 'Yes',
            repairType: sorCodeValue,
            description: selectedReason?.[0]?.description,
            channel: RepairChannel.ColleagueSelfServe,
            raisedDate: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss"),
            isAnaType: isAnaTypeValue,
            tenureCode: tenureCode,
            isV14Upgradable: selectedReason?.[0]?.isV14Upgradable,
            workProgramme: priorityWorkProgramme,
            premisesType: assetDetails?.assetType,
            hasSeasonalPriority: selectedReason?.[0]?.hasSeasonalPriority ?? false
        }
        try {
            const supportedResidentTenureCodeList = (await api.GetAppConfigToggleValue(
                "SupportedResidentTenureCodes"
            ))?.value;
            if (!isCurrentRepairReason(requestVersion)) {
                return;
            }
            dispatch(isSupportedResident(supportedResidentTenureCodeList?.includes(tenureCode)));
            return (await api.repairPriorityDetermination(repairPriorityPayload))?.repairPriority;
        } catch (e) {
            console.error(e);
            return "";
        }
    }

    const checkEnhancedRepairEligibilities = async (isEmergencyValue: any, sorValue: any, requestVersion: number) => {
        // call Enhanced Repair Eligibility api
        try {
            const enhancedRepairEligibilityPayload = {
                "priority": isEmergencyValue,
                "sor": sorValue,
                "channel": "ColleagueSelfService",
                "userRoles": localStorage.getItem('user_role') || "",
            };
            const repairEnhancedEligibility = await api.postEnhancedRepairEligibility(enhancedRepairEligibilityPayload);
            if (!isCurrentRepairReason(requestVersion)) {
                return;
            }

            if (repairEnhancedEligibility?.isEligible === false) {
                setSorError(repairEnhancedEligibility?.errorCode);
                setIsOrbisBlockMsg(true);
                props.setisDisabledOrbis(true);
                setErrorCode("");
            } else {
                setIsOrbisBlockMsg(false);
                props.setisDisabledOrbis(false);
            }

        } catch (e) {
            if (!isCurrentRepairReason(requestVersion)) {
                return;
            }
            console.log(e);
            props.history.push("/GenericError");
        }
    }

    const handleEmergencyUserSelection = (e: { target: { value: any } }) => {
        // Dispatch userChosenEmergencyQuestion from RepairReason ony for AR1
        if (e.target.value === 'Yes') {
            dispatch(priorityCode(RepairPriorityCode.Emergency));
        }
        if (e.target.value === 'No' && (displayEmergencyValue === 'Yes' || priorityFromDrools === '' || priorityFromDrools === RepairPriorityCode.Emergency) && selectedRepairReason.length > 0) {
            emergencyDropDownSelectedValue = e.target.value;
            void checkForRepairPriorityUpdates(selectedRepairReason);
        }
        setDisplayEmergencyValue(e.target.value)
        dispatch(selectedRepairReasonPriorityOverride(e.target.value == "Yes" ? RepairPriority.Emergency : RepairPriority.NextAvailable));
        dispatch(userChosenEmergencyQuestion(e.target.value));
        dispatch(selectedIsEmergencyValue(e.target.value));
        setRepairPriorityMessageForEnhancedHubRepairJourney(workorderChoosePriorityOfRepairPermission, e.target.value);
    }

    const checkForRepairPriorityUpdates = async (selectedReason: any, requestVersion = repairReasonRequestVersion.current) => {
        try {
            dispatch(selectedRepairReasonPriorityOverride(null));


            const determinedRepairPriorityLvl2 = await priorityDeterminationCallAPI(selectedReason, requestVersion);
            let repairPriority: any = await getRepairPriority(determinedRepairPriorityLvl2);
            if (!isCurrentRepairReason(requestVersion)) {
                return;
            }
            dispatch(priorityCode(determinedRepairPriorityLvl2));
            dispatch(userChosenEmergencyQuestion(""));

            if (
                isNullOrUndefined(repairPriority) &&
                fetchedRepairReasonsSelection &&
                fetchedRepairReasonsSelection?.length > 0
            ) {
                // Fall back to Repair reason priority if error from drools
                repairPriority = fetchedRepairReasonsSelection?.find(
                    (reasonObject: any) => {
                        return reasonObject.description === selectedReason[0]?.description;
                    }
                ).priority;
            }

            dispatch(selectedRepairReasonPriorityOverride(repairPriority));
            dispatch(selectedRepairReasonDefaultPriority(repairPriority));
            if (workorderChoosePriorityOfRepairPermission) {
                // Dispatch userChosenEmergencyQuestion from RepairReason ony for AR1
                let ar1EmergencySelectionValue = repairPriority === RepairPriority.Emergency ? "Yes" : "No";
                setDisplayEmergencyValue(ar1EmergencySelectionValue);
                dispatch(userChosenEmergencyQuestion(ar1EmergencySelectionValue));
                dispatch(selectedIsEmergencyValue(ar1EmergencySelectionValue));
            }

            setpriorityFromDrools(determinedRepairPriorityLvl2 ?? "");
        } catch (e) {
            if (!isCurrentRepairReason(requestVersion)) {
                return;
            }
            console.error(e);
            props.history.push("/GenericError");
        }
    }

    const checkRepairEligibility = async (selectedReason: any, sorCode: any, preserveAssessmentDecisions: boolean, requestVersion: number) => {
        const EMEPriority = preserveAssessmentDecisions ? currentPriorityCode : await priorityDeterminationCallAPI(selectedReason, requestVersion);
        if (!isCurrentRepairReason(requestVersion)) {
            return;
        }
        await checkEnhancedRepairEligibilities(EMEPriority, sorCode, requestVersion);
        if (!isCurrentRepairReason(requestVersion)) {
            return;
        }

        const options: GetRepairEligibilityOptions = {
            assetType: premisesType,
            maintenanceResponsibility: maintsResp,
            repairResponsibility: repairResp,
            additionalRepairInfo,
            isRepairEligible,
            isCustomerView,
            sorCode,
            uprn,
            isInDefects,
            heatingRepairContext,
            assetSubType,
            parentAssetType
        }

        props.setisDisabled(true);
        const eligibilityResponse = await api.getRepairEligibility(options);
        if (!isCurrentRepairReason(requestVersion)) {
            return;
        }
        dispatch(userChosenEligibilityErrorCode(eligibilityResponse));

        props.setisDisabled(true)
        if (eligibilityResponse?.length <= 0) {
            setShowAlertsAndWarningsDisplay("block");
            props.setisDisabled(true);
            return;
        }

        const isEligible = eligibilityResponse[0].isEligible;
        const errorCode = eligibilityResponse[0].errorCode ?? "";

        if (!isUndefinedNullOrEmpty(errorCode)) {
            setShowAlertsAndWarningsDisplay("block");
            setErrorCode(errorCode);
        }

        if (!isEligible) {
            props.setisDisabled(true);
        } else {
            props.setisDisabled(false);
        }

        setIsLoading(false);
    };

    const inputTextChangeHandler = (event: any, newValue: any) => {
        dispatch(userChosenNotifyAll(null));
        dispatch(userChosenCovidQuestion(""));
        dispatch(userChosenVulnerabilityAdditionalInformation(""));
        dispatch(userChosenVulnerabilityQuestion("No"));
        dispatch(userChosenEmergencyQuestion(""));
        dispatch(isEditState(false));
        dispatch(userChosenVandalismAdditionalInformation(""));
        dispatch(userChosenVandalismQuestion("No"));
        dispatch(userChosenDuplicateQuestion(""));
        dispatch(selectedIsEmergencyValue(''));
        dispatch(userChosenHighLevelDescription(newValue));
        // Removing hhsrs hazard and saverity value
        dispatch(saveHazardType(''));
        dispatch(saveSaverityScore(''));
        dispatch(saveHHSRSOption("no"));
        dispatch(SavehasActiveHazardCase(false));
        dispatch(saveActiveHazardCaseDetails({}));
        setFetchedRepairReasonsData(props.suggestions);


        if (((
            sorErrorCodeValue == SorErrorEnumCode.E28 ||
            sorErrorCodeValue == SorErrorEnumCode.E29 ||
            sorErrorCodeValue == SorErrorEnumCode.E30 ||
            sorErrorCodeValue == SorErrorEnumCode.E31 ||
            sorErrorCodeValue == SorErrorEnumCode.E32) && inputValue == "Heating or hot water repair") ||
            sorErrorCodeValue == SorErrorEnumCode.E8 || sorErrorCodeValue == SorErrorEnumCode.E4 ||
            sorErrorCodeValue == SorErrorEnumCode.E21 || sorErrorCodeValue == SorErrorEnumCode.E25 ||
            sorErrorCodeValue == SorErrorEnumCode.E22 || sorErrorCodeValue == SorErrorEnumCode.E9) {
            props.setisDisabled(true);
        }

    };

    const suggestionClickHandler = (event: any, newInputValue: any) => {
        dispatch(clearMediaFiles([]));
        dispatch(userChosenUploadedMediaIdentifiers([]));
        dispatch(userChosenSOR(""));
        dispatch(sorErrorCode(""));
        dispatch(getRepairResp(""));
        dispatch(getHeatingHotWaterCase(""));
        dispatch(getMaintResp(""));
        dispatch(getDeterminedContractorDetails(""));
        dispatch(getContractorName(""));
        dispatch(getContractorPayload(""));
        dispatch(selectedSorCode(null));
        dispatch(removeAllDMCData(null));
        dispatch(dmcCheckSavedAnswer(""))
        setSorError("");
        setSorValue("");
        props.setisDisabled(true);
        setShowAlertsAndWarningsDisplay("none");
        if (EditState === true) {
            dispatch(userChosenNotifyAll(null));
            dispatch(userChosenCovidQuestion(""));
            dispatch(userChosenVulnerabilityAdditionalInformation(""));
            dispatch(userChosenVulnerabilityQuestion("No"));
            dispatch(userChosenEmergencyQuestion(""));
            dispatch(isEditState(false));
            if (!IsRecall) {
                dispatch(userChosenVandalismAdditionalInformation(""));
                dispatch(userChosenVandalismQuestion("No"));
            }
            dispatch(userChosenDuplicateQuestion(""));
        }
        setInputValue(newInputValue);
        if (newInputValue !== "") {
            setFetchedRepairReasonsData(props.suggestions);
            dispatch(userTypedRepairReasons(newInputValue));
            dispatch(selectedRepairReasonPriorityOverride(null));
            dispatch(selectedRepairReasonDefaultPriority(null));
            updateStoreForNewRepairReasonSelection(newInputValue, true);
            setSelectedValue(true);
        } else {
            repairReasonRequestVersion.current += 1;
            setIsLoading(false);
            props.onRepairReasonLoadingChange?.(false);
            setSelectedValue(false);
            props.setisDisabled(true);
        }

    };


    const suggestionListRender2 = () => {
        if (
            (errorCode == EligibilityErrorCode.SSR037 ||
                errorCode == EligibilityErrorCode.E21) &&
            inputValue
        ) {
            let errorCodeArray: string[] = [];
            errorCodeArray = t(errorCode).split("#");
            let errorCodeValue = errorCodeArray[0];
            let errorCodeValue1 = errorCodeArray[1];
            if (errorCode === EligibilityErrorCode.SSR037) {
                props.setisDisabled(false);
            }
            else
                props.setisDisabled(true);

            errorCodeArray = errorCodeArray.slice(2);
            let items = errorCodeArray.map((item, index) => {
                const itemKey = `${errorCode}-${index}-${item}`;
                const itemParts = item.split('@@');
                const itemContent = itemParts.length > 1 ? (
                    <>{itemParts[0]} <ul className="ul20">{itemParts.slice(1, 3).map(content => <li className="" key={`${itemKey}-${content}`}>{content}</li>)}</ul></>
                ) : item;
                let listItem;

                if (errorCode === EligibilityErrorCode.SSR037 && index !== 2) {
                    listItem = <li key={itemKey} className="ul-none">{itemContent}</li>;
                } else if (index === 2 && errorCode === EligibilityErrorCode.SSR037) {
                    const itemPartsByColon = item.split(":");
                    listItem = (
                        <strong>
                            <li key={itemKey} className="ul-none">
                                {itemPartsByColon[0]}<strong><p>{itemPartsByColon[1]}</p></strong>
                            </li>
                        </strong>
                    );
                } else {
                    listItem = <li key={itemKey}>{item}</li>;
                }

                return listItem;
            });
            suggestionList = (
                <div
                    data-testid="alert-warning"
                    style={{ display: showAlertsAndWarningsDisplay }}
                    className="warning mb-8"
                    role="alert"
                    placeholder="alert-message"
                >
                    {sorError !== SorErrorEnumCode.E36 && <div className="w-full px-2 py-2 bg-red-20 flex items-center">
                        <div className="px-4 pr-8">
                            <i className="fas fa-exclamation-circle me-2 text-brick-100 w-6 h-6 bolder-font"></i>
                        </div>
                        <div className="flex items-center text-black pt-2">
                            <p className="w-full text-left my-2 font-AvantGardeGothic-Md pb-2">
                                <span className="mt-2"><b>{errorCodeValue}</b></span><br /><br />
                                <span className="pt-2 mt-2">{errorCodeValue1}</span>

                                {errorCode == EligibilityErrorCode.SSR037 ? (
                                    <ol>{items}</ol>
                                ) : (
                                    <ul>{items}</ul>
                                )}
                            </p>
                        </div>
                    </div>}
                </div>
            );
        } else if (errorCode == EligibilityErrorCode.E23 && !inputValue) {
            suggestionList = (
                <div
                    data-testid="alert-warning"
                    style={{ display: showAlertsAndWarningsDisplay }}
                    className="alert alert-warning error-reason global-txt"
                    role="alert"
                    placeholder="alert-message"
                >
                    <span className="global-error-icon covid-error">
                        <i className="fas fa-exclamation me-2"></i>
                    </span>
                    <span className="remove-margin-left">{t(errorCode)}</span>
                </div>
            );
        } else if (errorCode && inputValue) {
            suggestionList = (
                <div
                    data-testid="alert-warning"
                    style={{ display: showAlertsAndWarningsDisplay }}
                    className="alert mb-8 container"
                    role="alert"
                    placeholder="alert-message"
                >
                    <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
                        <div className="px-4 pr-8">
                            <i className="fa fa-bullhorn text-purple-100 w-6 h-6 purple-icon"></i>
                        </div>
                        <div className="flex items-center text-black">
                            <p className="w-full text-left font-AvantGardeGothic-Md">
                                {t(errorCode)}
                            </p>
                        </div>
                    </div>
                </div>
            );
        } else if (isLoading) {
            suggestionList = (
                <Loader
                    type="ThreeDots"
                    color="#00BFFF"
                    height={50}
                    width={50}
                    timeout={5000}
                />
            );
        }
    }
    const suggestionListRender = () => {
        if (
            props.locatioAlert.length > 1 &&
            !inputValue &&
            (RepairLocationId == 0 || RepairLocationId === "No option selected")
        ) {
            suggestionList = (
                <div
                    data-testid="alert-warning"
                    className="error mb-8"
                    role="alert"
                    placeholder="alert-message"
                >
                    <div className="w-full px-2 py-2 bg-yellow flex items-center">
                        <div className="px-4 pr-8">
                            <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
                        </div>
                        <div className="flex items-center">
                            <p
                                data-testid="locatioAlert_0"
                                className="w-full text-left my-2 font-AvantGardeGothic-Md"
                            >
                                {props.locatioAlert[0]}
                            </p>
                        </div>
                    </div>
                    <div className="w-full px-2 py-2 bg-yellow flex items-center">
                        <div className="px-4 pr-8">
                            <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
                        </div>
                        <div className="flex items-center">
                            <p
                                data-testid="locatioAlert_1"
                                className="w-full text-left my-2 font-AvantGardeGothic-Md"
                            >
                                {props.locatioAlert[1]}
                            </p>
                        </div>
                    </div>
                </div>
            );
        } else if (
            props.locatioAlert.length == 1 &&
            (!inputValue ||
                RepairLocationId == 0 ||
                RepairLocationId === "No option selected")
        ) {
            suggestionList = (
                <div
                    data-testid="alert-warning"
                    className="error mb-8"
                    role="alert"
                    placeholder="alert-message"
                >
                    <div className="w-full px-2 py-2 bg-yellow flex items-center">
                        <div className="px-4 pr-8">
                            <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
                        </div>
                        <div className="flex items-center">
                            <p
                                data-testid="locatioAlert"
                                className="w-full text-left my-2 font-AvantGardeGothic-Md"
                            >
                                {props.locatioAlert}
                            </p>
                        </div>
                    </div>
                </div>
            );
        } else if (
            (isNullOrUndefined(props?.suggestions) || !props?.suggestions?.length) &&
            inputValue && !selectedSorCodeValue && !fetchRepairReasonsInProgressFromState
        ) {
            props.setisDisabled(true);
            suggestionList = (
                <div className="error mb-8" role="alert">
                    <div className="w-full px-2 py-2 bg-yellow flex items-center">
                        <div className="px-4 pr-8">
                            <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
                        </div>
                        <div className="flex items-center text-black">
                            <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                                {t("Repair_Reason_NoMatch_Message")}
                            </p>
                        </div>
                    </div>
                </div>
            );
        } else if (errorCode == EligibilityErrorCode.SSR037 && !inputValue) {
            let errorCodeArray: string[] = [];
            errorCodeArray = t(errorCode).split("#");
            let errorCodeValue = errorCodeArray[0];
            let errorCodeValue1 = errorCodeArray[1];
            errorCodeArray = errorCodeArray.slice(2);
            let items = errorCodeArray.map((item, index) =>
                errorCode == EligibilityErrorCode.SSR037 && index !== 2 ? (
                    <li key={item} className="ul-none">
                        {item}
                    </li>
                ) : (
                    <strong key={item}>
                        <li className="ul-none">
                            {item.split(":")[0]}:<strong>{item.split(":")[1]}</strong>
                        </li>
                    </strong>
                )
            );
            suggestionList = (
                <div
                    data-testid="alert-warning"
                    style={{ display: showAlertsAndWarningsDisplay }}
                    className="alert alert-warning error-reason global-txt top-btm-padding"
                    role="alert"
                    placeholder="alert-message"
                >
                    <span className="global-error-icon covid-error">
                        <i className="fas fa-exclamation me-2"></i>
                    </span>
                    <span><b>{errorCodeValue}</b></span><br />
                    <span>  {errorCodeValue1}</span>
                    {errorCode == EligibilityErrorCode.SSR037 ? (
                        <ol>{items}</ol>
                    ) : (
                        <ul>{items}</ul>
                    )}
                </div>
            );
        }
        else {
            suggestionListRender2()
        }
    }
    suggestionListRender();
    const hasSorErrorMessage = sorError === SorErrorEnumCode.E28 ||
        sorError === SorErrorEnumCode.E29 ||
        sorError === SorErrorEnumCode.E30 ||
        sorError === SorErrorEnumCode.PROROOFINGALERT ||
        sorError === SorErrorEnumCode.E31;
    const hasOrbisBlockMessage = isOrbisBlockMsg === true &&
        (sorError === SorErrorEnumCode.E35 || sorError === SorErrorEnumCode.E36);
    const hasE32Message = sorError === SorErrorEnumCode.E32 &&
        workorderNoTriageForHHWRepairsPremission;

    return (
        <>
            <div className="h5" id="repreason-div1">
                <h2 className="text-purple-100 text-2xl mb-2 global-txt">
                    {t("Repair_Reason_Main_Header_Text")}
                </h2>
            </div>
            <p className="text-base my-0 global-txt" id="repreason-p">
                {t("Repair_Reason_Header_Text")}
            </p>
            {fetchedRepairReasonsData && (
                <Autocomplete
                    className="pt-01 width-css global-txt pb-2 border-color"
                    data-testid="high-level-repair"
                    onChange={inputTextChangeHandler}
                    inputValue={inputValue}
                    disabled={isRecallValue}
                    onInputChange={suggestionClickHandler}
                    id="high-level-repair"
                    freeSolo
                    disableClearable
                    filterOptions={(options, state) => props.suggestions}
                    options={fetchedRepairReasonsData}
                    size="small"
                    renderInput={(params) => (
                        <label className="w-full global-txt">
                            <TextField
                                {...params}
                                margin="normal"
                                placeholder={t("repair_reason_placeholder")}
                                id="repreason-text"
                                className="high-level-input pt-01 global-txt"
                            />
                        </label>
                    )}
                />
            )}


            {(workorderChoosePriorityOfRepairPermission && (!isResumedRepair || showResumedEmergencyDropdown) && (selectedSorCodeValue === "" || !(dmcInspectionSorCodes?.includes(selectedSorCodeValue))) && (isHHSRSRepairEnabledCheck !== true || !isHazardRepair || (selectedRepairReason[0]?.isPreAssessmentRequired === true && (isHHSRSAssessmentCompletedCheck !== true || (isResumedRepair && showResumedEmergencyDropdown))))) && (
                <>
                    <div className="h5" id="reploc-div1">
                        <h2 className="text-purple-100 text-2xl mb-2 global-txt ">
                            {t("repair_emergency_heading")}
                        </h2>
                    </div>
                    <select
                        id="reploc-sel"
                        data-testid="dropDownLocation"
                        name="dropDownLocation"
                        placeholder="Select..."
                        aria-label="reploc-sel"
                        onChange={handleEmergencyUserSelection}
                        value={displayEmergencyValue}
                        className="block width-css mt-1 text-black global-txt rounded border-grey"
                    >
                        <option
                            value="No"
                            className="block mt-1 width-css mt-8 text-black global-txt"
                        >
                            No
                        </option>
                        <option
                            value="Yes"
                            className="block mt-1 width-css mt-8 text-black global-txt"
                        >
                            Yes
                        </option>

                    </select>
                    <div className="alert mt-8 p-0 container" role="alert">
                        <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
                            <div className="px-4 pr-8">
                                <i className="fa fa-bullhorn text-purple-100 w-6 purple-icon"></i>
                            </div>
                            <div className="flex items-center text-black" data-testid="alertWarning">
                                <p className="w-full text-left font-AvantGardeGothic-Md">
                                    {t(emergencyAlertText)}
                                </p>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {suggestionList}

            <div>
                {hasSorErrorMessage && (
                    <div className="w-full px-4 py-2 bg-yellow flex items-center mb-4">
                        <div className="px-4 pr-8">
                            <svg aria-hidden="true" focusable="false"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                fill="currentColor"
                                className="text-brick-70 w-6 h-6"
                            >
                                <path d="M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"></path>
                            </svg>
                        </div>
                        <div className="flex items-center">
                            <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                                {t(sorError)}
                            </p>
                        </div>
                    </div>
                )}
                {!hasSorErrorMessage && blockLoading && (
                    <Loader
                        type="ThreeDots"
                        color="#00BFFF"
                        height={70}
                        width={50}
                    />
                )}
                {!hasSorErrorMessage && !blockLoading && hasOrbisBlockMessage && (
                    <div className="w-full sm:px-0 px-4 py-4 bg-yellow mb-4 flex items-center">
                        <div className="w-6 h-6 md:px-4 mr-6 sm:pl-2">
                            <svg aria-hidden="true" focusable="false"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                fill="currentColor"
                                className="text-brick-70 w-6 h-6"
                            >
                                <path d="M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"></path>
                            </svg>
                        </div>
                        {sorError === SorErrorEnumCode.E35 &&
                            <div className="flex flex-wrap flex-col">
                                <div className="row items-center ">
                                    <p className="w-full text-left my-2 font-AvantGardeGothic-Md text-lg">
                                        {t("E35")}
                                    </p>
                                </div>
                            </div>
                        }

                        {sorError === SorErrorEnumCode.E36 &&
                            <div className="flex flex-wrap flex-col">
                                <div className="row items-center ">
                                    <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                                        {t("E36")}
                                    </p>
                                </div>
                            </div>
                        }

                    </div>
                )}
                {!hasSorErrorMessage && !blockLoading && !hasOrbisBlockMessage && hasE32Message && (
                    <div className="w-full sm:px-0 px-4 py-4 bg-yellow mb-4 flex items-center">
                        <div className="w-6 h-6 md:px-4 mr-6 sm:pl-2">
                            <svg aria-hidden="true" focusable="false"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                fill="currentColor"
                                className="text-brick-70 w-6 h-6"
                            >
                                <path d="M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"></path>
                            </svg>
                        </div>
                        <div className="flex flex-wrap flex-col">
                            <div className="row items-center ">
                                <p className="w-full text-left my-2 font-AvantGardeGothic-Md text-lg">
                                    {t("E32_1")}
                                </p>
                            </div>

                            <div className="row items-center">
                                <p className="mt-1 mb-2 text-sm">{t("E32_2")}</p>
                                <p className="mt-0 text-sm">{t("E32_3")}</p>
                            </div>

                            <div className="row items-center pb-2 mr-1">
                                {sorList !== undefined ? (
                                    <select
                                        className="block w-full mt-0 ml-3 w-95"
                                        onChange={handleChangeSorCode}
                                        value={sorValue}
                                        data-testid="sor-change-value"
                                    >
                                        <option>Select</option>
                                        {sorList.map((sor: any) => (
                                            <option key={sor.sorCode} value={sor.sorCode}>
                                                {sor.trade}
                                            </option>
                                        ))}
                                    </select>
                                ) : null}
                            </div>


                        </div>

                    </div>
                )}
                {!hasSorErrorMessage && !blockLoading && !hasOrbisBlockMessage && !hasE32Message && (
                    <>{enableButtonPermission}</>
                )}
            </div>
        </>
    );
};

export const heatingAttributeFromResponsibilities = (
    responsibilities: MaintenanceResponsibility[]
) => {
    if (!responsibilities) return "";

    const elementsToCheck = new Set<string>([
        "HEAT",
        "HEATGAS",
        "HEATOIL",
        "HEATELEC",
    ]);
    return responsibilities
        .filter((resp) => elementsToCheck.has(resp.type))
        .map((resp) => resp.value)
        .filter((value) => {
            const valueLowerCase = value?.toLowerCase();
            return (
                !!value &&
                valueLowerCase !== "null" &&
                valueLowerCase !== "unknown" &&
                valueLowerCase !== "none"
            );
        })
        .join("+");
};

export const getSorCode = (
    selectedReason: any,
    supplimentaryCodes: string[]
): string => {
    const isTotalLossOfWaterWithSupplementaryCodes =
        selectedReason?.description === "Total loss of water" &&
        supplimentaryCodes?.includes("FISPUMPS02");

    return isTotalLossOfWaterWithSupplementaryCodes
        ? "COMPUMP"
        : selectedReason?.sors?.[0]?.sorCode;
};
export default RepairReason;
